import { Injectable } from '@angular/core';
import { getDistance } from 'ol/sphere';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import Circle from 'ol/style/Circle';
import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import { circular } from 'ol/geom/Polygon';
import Feature from 'ol/Feature';
import * as proj from 'ol/proj';
import {FormbirdInjectorService} from 'formbird-services';

import {SclMapConstantService} from './scl-map-constant.service';
import { AddressDetails } from './AddressDetails';

const sclMapConstant = SclMapConstantService;

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoPSMAService {
  notificationService: any;
  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
  }

  autocompleteUrl = 'https://api.psma.com.au/v1/predictive/address?query=';
  addressUrl = 'https://api.psma.com.au/v1/predictive/address/';
  geocodeUrl = 'https://api.psma.com.au/v1/addresses?radius=';
  geocodeUrlNext = 'https://api.psma.com.au/v1/addresses/'; // GAVIC419864439/geo/
  apiKeyReverse;
  autocompleteBox;
  apiKey;
  waitTime = 5000; // miliseconds
  country; language; reverseNoAddressIncrement = 0; reverseNoAddressRetry = 0;
  enableReverseRadiusDisplay = false; showReverseAddressPoint = 0; map;
  psmaRadius = 50; psmaHasStreetData = false;
  psmaAddressData = []; psmaAddressDetailUrl = ''; dropPinSelectsAddres = false;
  reverseAddress = []; EPSG;
  psmaPointStyle; psmaLayer; psmaSourceVector; psmaPoints = [];
  psmaFinalRadius = 0; psmaOutOfRadius = []; psmaIndexAddress = -1;
  psmaCountGetGPS = 0; count;
  isFeatureRemoving = false; // use to stop reverse service get address
  page = 1;
  callLookUp = false;
  initObj; dropPinSelectsAddress; lat; lon; radius; preText = ''; state; autocompleteStreet;
  hasPrimaryAssetAddressLookup = false; primaryAssetAddressLookupRadius; // 15393


  setupReverse(geo) {
    if ( geo.reverseNoAddressIncrement ) {
      this.reverseNoAddressIncrement = geo.reverseNoAddressIncrement;
    }
    if ( geo.reverseNoAddressRetry ) {
      this.reverseNoAddressRetry = (geo.reverseNoAddressRetry <= 0 ? 1 : (geo.reverseNoAddressRetry + 1) ) ;
    }
    if ( geo.enableReverseRadiusDisplay ) {
      this.enableReverseRadiusDisplay = geo.enableReverseRadiusDisplay;
    }
    if ( geo.showReverseAddressPoint ) {
      this.showReverseAddressPoint = geo.showReverseAddressPoint;
    }
    if (geo.radius) {
      this.psmaRadius = geo.radius;
    }
    if (this.initObj.assetField.dropPinSelectsAddress && geo.dropPinSelectsAddress) {
      this.dropPinSelectsAddress = this.initObj.assetField.dropPinSelectsAddress;
    } else if (geo.addressDetailUrl) {
      this.psmaAddressDetailUrl = geo.addressDetailUrl;
    }
    if (geo.primaryAssetAddressLookupRadius) { this.primaryAssetAddressLookupRadius = geo.primaryAssetAddressLookupRadius; }

    this.count = (this.reverseNoAddressRetry <= 0 ? 1 : this.reverseNoAddressRetry);
    this.reverseAddress = []; // reset
    this.psmaFinalRadius = 0;
    this.psmaOutOfRadius = [];
    this.psmaIndexAddress = -1;
    this.psmaCountGetGPS = 0;
    this.isFeatureRemoving = false;
    this.psmaHasStreetData = false;
    this.psmaAddressData = [];
    this.callLookUp = false;
  }

  verifyObj(addressDetails) {
    const isNull = (strVal) => {
      if (!strVal || strVal === 'null') {
        return false;
      } else { return true; }
    };

    const processData: any = {};
    processData.street_type             = !isNull(addressDetails.streetType)              ? '' : addressDetails.streetType;
    // SUFFIX
    processData.street_suffix             = !isNull(addressDetails.streetSuffix)              ? '' : addressDetails.streetSuffix;
    processData.street_type_description = !isNull(addressDetails.streetTypeDescription)   ? '' : addressDetails.streetTypeDescription;
    processData.street_number_2         = !isNull(addressDetails.streetNumber2)           ? '' : addressDetails.streetNumber2;
    processData.unit_no                 = !isNull(addressDetails.complexUnitIdentifier)   ? '' : addressDetails.complexUnitIdentifier;
    processData.complex_unit_type      = !isNull(addressDetails.complexUnitType)        ? '' : addressDetails.complexUnitType;
    processData.complex_level_type      = !isNull(addressDetails.complexLevelType)        ? '' : addressDetails.complexLevelType;
    processData.complex_level_number    = !isNull(addressDetails.complexLevelNumber)      ? '' : addressDetails.complexLevelNumber;
    processData.street_number_1         = !isNull(addressDetails.streetNumber1)           ? '' : addressDetails.streetNumber1;
    processData.street_name             = !isNull(addressDetails.streetName)              ? '' : addressDetails.streetName;
    processData.locality_name           = !isNull(addressDetails.localityName)            ? '' : addressDetails.localityName;
    processData.postcode                = !isNull(addressDetails.postcode)                ? '' : addressDetails.postcode;
    processData.state_territory         = !isNull(addressDetails.stateTerritory)          ? '' : addressDetails.stateTerritory;
    processData.site_name             = !isNull(addressDetails.siteName)              ? '' : addressDetails.siteName;

    return processData;
  }

  updateStreetData(coor, addressData) {
    const streetData: any = new AddressDetails();
    streetData.properties.unitNo = addressData.unit_no;
    // DUAL NUMBERS
    streetData.properties.streetNo = addressData.street_number_1 +
      (addressData.street_number_2 === '' ? '' : '-' + addressData.street_number_2).trim();
    streetData.properties.street = (addressData.street_name + ' ' +
      (addressData.street_type_description === '' ? addressData.street_type :
        addressData.street_type_description ) + ' ' + (addressData.street_suffix === '' ?
        '' : addressData.street_suffix) ).trim();
    streetData.properties.suburb = addressData.locality_name;
    streetData.properties.postcode = addressData.postcode;
    streetData.properties.state = addressData.state_territory;
    if (addressData.site_name) {
      streetData.properties.locationDescription = addressData.site_name;
    }
    if (addressData.complex_unit_type) {
      (streetData.properties.locationDescription += '\n' + addressData.complex_unit_type + ' ' + addressData.unit_no ).trim();
    }
    if (addressData.complex_level_type) {
      (streetData.properties.locationDescription += '\n' + addressData.complex_level_type + ' ' + addressData.complex_level_number ).trim();
    }

    if (coor != null) {
      streetData.geometry.coordinates[0] = coor[0]; // lon
      streetData.geometry.coordinates[1] = coor[1]; // lat
    }
    return streetData;
  }

  reverse( coor, cb, cbErr, cbTimeout) {
    if ( this.apiKeyReverse == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma address reverse: apiKeyReverse is null');
      }
      return;
    }

    const lon    = coor[0];
    const lat    = coor[1];
    const radius = coor[2];
    if (coor.length < 4 ) {
      coor[3] = (this.reverseNoAddressRetry <= 0 ? 1 : this.reverseNoAddressRetry);
    }
    const count = coor[3];

    // let psmaFinalRadius = radius;
    const self = this;
    self.lat = lat;
    self.lon = lon;
    self.count = count;
    self.radius = 1;
    if (this.hasPrimaryAssetAddressLookup === true) { self.radius = this.primaryAssetAddressLookupRadius; }
    else { self.radius = radius; }

    if (this.enableReverseRadiusDisplay ) {
      this.createLayer();
      this.removeFeatures(false);
    }

    // draw points which are out of previous radius
    for (let i = 0 ; i < this.psmaOutOfRadius.length ; i++) {
      const item = this.psmaOutOfRadius[i];
      if (item.distance <= this.psmaFinalRadius) {
        this.createPoint(item.coor, item.index, item.distance);
      }
    }

    this.psmaOutOfRadius = [];

    // draw circle
    if (this.enableReverseRadiusDisplay ) {
      self.createPointClick([self.lon, self.lat], self.radius);
    }
    const reverseAddressText = [];
    const link = this.geocodeUrl + self.radius + '&latLong=' + self.lat + ',' + self.lon + '&page=' + this.page;

    this.initObj.httpService.getAPI(link,
      {timeout: this.waitTime},
      {Authorization: this.apiKeyReverse}
    ).subscribe(result => {
        if (self.callLookUp) { return; }
        const resData = result.data;
        if (resData) {
          if (resData.length > 0) {
            for (let i = 0 ; i < resData.length ; i ++) {
              const item = resData[i];
              if (item.addressId && self.reverseAddress.indexOf(item.addressId) === -1) {
                self.reverseAddress.push(item.addressId);
                reverseAddressText.push(item.formattedAddress);
              }
            }
            if (self.psmaIndexAddress === -1) {
              self.psmaIndexAddress = 1;
            }
            self.psmaReversItem(resData[0].addressId, resData[0].formattedAddress, 1, [self.lon, self.lat], self.radius
              , self.count, self.page, function(pRadius, obj, addressDetails) {
              let finalRadius = 0;
              if(self.hasPrimaryAssetAddressLookup === true) {
                  finalRadius = self.primaryAssetAddressLookupRadius;
              } else {
                  finalRadius = (self.psmaRadius < 1 ? 1 : self.psmaRadius) +
                  (self.reverseNoAddressIncrement * self.reverseNoAddressRetry);
                  if(finalRadius > 100) {
                      finalRadius = 100;
                  }
              }

              const verifiedObj = this.verifyObj(addressDetails);
              if (obj.distance <= finalRadius && obj.index === 1 && self.psmaHasStreetData === false) {
                self.psmaHasStreetData = true;
                // SUFFIX
                const streetData = this.updateStreetData((self.dropPinSelectsAddress === true ? obj.coor : coor), verifiedObj);
                // Simplified call to pass object

                if (cb && typeof cb === 'function') {
                  cb(streetData, { lat: obj.coor[1], lng: obj.coor[0] });
                }

              } else if (obj.distance > finalRadius && obj.index === 1 && self.psmaHasStreetData === false && self.count === 1) {
                let minDistance = obj.distance;
                let idx = obj.index;

                for (let i = 0 ; i < self.psmaAddressData.length ; i++) {
                  const item = self.psmaAddressData[i];
                  if (minDistance > item.obj.distance ) {
                    minDistance = item.obj.distance;
                    idx = obj.index;
                  }
                }

                //// logger.info("minDistance = " + JSON.stringify(self.psmaAddressData[idx]));
                if (minDistance > finalRadius) {
                  this.notificationService.warning('No address could be determined ' + finalRadius + ' metres from that point. ' +
                  'Please try a different point, if you need an address.');
                  if (cbErr && typeof cbErr === 'function') {
                    cbErr();
                  }
                } else {
                  self.psmaHasStreetData   = true;
                  addressDetails      = self.psmaAddressData[idx].addressDetails;
                  // SUFFIX
                  const streetData = this.updateStreetData((self.dropPinSelectsAddress === true ? obj.coor : null), verifiedObj);

                  if (cb && typeof cb === 'function') {
                    cb(streetData, { lat: obj.coor[1], lng: obj.coor[0] });
                  }
                }
              }
            }.bind(this), () => {
              // error
              console.log('***** PSMA error undefined');
            });

            let allowDraw = false;
            if (self.enableReverseRadiusDisplay ) {
              if (self.reverseAddress.length > self.showReverseAddressPoint) {
                for (let i = self.reverseAddress.length - 1; i > self.showReverseAddressPoint - 1 ; --i) {
                  self.reverseAddress.splice(i, 1);
                }
                allowDraw = true;
              } else if (self.reverseAddress.length < self.showReverseAddressPoint
                && result.data && result.data.links && result.data.links.next) {
                self.page++;
                self.reverse([self.lon, self.lat, self.radius, self.count], cb, cbErr, cbTimeout);
                allowDraw = false;
              } else {
                allowDraw = true;
              }
            }

            if (allowDraw) {
              for (let i = 0; i < self.reverseAddress.length; i++) {
                self.psmaIndexAddress++;
                self.psmaReversItem(self.reverseAddress[i], reverseAddressText[i], self.psmaIndexAddress, [self.lon, self.lat]
                  , self.radius, self.count, self.page, function(radius1: any, obj, addressDetails) {
                  let idx = self.psmaOutOfRadius.findIndex(item => item.addressId === obj.addressId);
                  if (obj.distance > radius1 ) {
                    if (idx < 0) {
                      self.psmaOutOfRadius.push(obj);
                    }
                  } else {
                    self.createPoint(obj.coor, obj.index, obj.distance);
                  }
                  if (self.psmaOutOfRadius.length === self.reverseAddress.length && self.count > 1 ) {
                    self.count--;
                    self.radius += self.reverseNoAddressIncrement;
                    if (self.radius > 100) {
                      self.radius = 100;
                    }
                    self.reverse([self.lon, self.lat, self.radius, self.count], cb, cbErr, cbTimeout);
                  }
                  idx = self.psmaAddressData.findIndex(item => item.obj.addressId === obj.addressId);
                  if (idx < 0) {
                    self.psmaAddressData.push({obj, addressDetails});
                  }
                }.bind(this), () => {
                  // error
                  console.log('***** PSMA error undefined');
                });
              }
            }
          } else if (self.count > 1) {
            self.radius += self.reverseNoAddressIncrement;
            if (self.radius > 100) {
              self.radius = 100;
            }
            self.count -= 1;
            self.reverse([self.lon, self.lat, self.radius, self.count], cb, cbErr, cbTimeout);
          } else {
            let finalRadius = 0;
            if(self.hasPrimaryAssetAddressLookup === true) {
                finalRadius = self.primaryAssetAddressLookupRadius;
            } else {
                finalRadius = (self.psmaRadius < 1 ? 1 : self.psmaRadius) +
                (self.reverseNoAddressIncrement * self.reverseNoAddressRetry);
                if(finalRadius > 100) {
                    finalRadius = 100;
                }
            }
            this.notificationService.warning('No address could be determined ' + finalRadius + ' metres from that point. ' +
              'Please try a different point, if you need an address.');
            if (cbErr && typeof cbErr === 'function') {
              cbErr();
            }
          }
        } else {
          if (cbErr && typeof cbErr === 'function') {
            cbErr('PSMA reverse Error ');
          }
        }
      },
      error => {
        if ( error.status === -1) {
          if (cbTimeout && typeof cbTimeout === 'function') {
            cbTimeout();
          }
        } else {
          // logger.info(error);
          if (cbErr && typeof cbErr === 'function') {
            cbErr('PSMA reverse Error ' + error);
          }
        }
      });

  }

  // new reverseItem function
  psmaReversItem(addressId, formattedAddress, index, coorCenter, radius, count, page, cb, cbErr) {
    if ( this.apiKeyReverse == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma address reverse: apiKeyReverse is null');
      }
      return;
    }
    
    const link = this.geocodeUrlNext + addressId + '/?include=geo,addressDetails';
    const self = this;

    this.initObj.httpService.getAPI(link,
      null,
      {Authorization: this.apiKeyReverse}
    ).subscribe(dataResult => {
        if (self.callLookUp) { return; }
        if (dataResult && dataResult.geo ) {

          const coor = dataResult.geo.geometry.coordinates;
          let distance = 0;
          distance = getDistance(coor, coorCenter); // openlayer 5 // 15737

          console.log('addressId = ' + addressId
             + '\n\t - address text = ' + formattedAddress
             + '\n\t - distance = ' + distance + '\n\t - radius = ' + radius
             + '\n\t - coor = ' + coor + '\n\t - coorCenter = ' + coorCenter);

          const obj = {coor, index, distance, addressId : dataResult.addressId};
          if (cb && typeof cb === 'function') { cb( radius, obj, dataResult.addressDetails ); }
        } else {
          if (cbErr && typeof cbErr === 'function') {
            cbErr('PSMA reverse Item Error ');
          }
        }
      },
      error => {
        // logger.info(error);
        if (cbErr && typeof cbErr === 'function') {
          cbErr('PSMA reverse Error ' + error);
        }
      });

  }

  psmaStyleFunction(feature, resolution) {
    if (typeof feature !== 'object' || typeof feature.getProperties() === 'undefined') { return null; }
    const description = feature.getProperties().description;


    const label = (typeof description === 'undefined' || description === null) ? '' : description + '';
    //// logger.info("description = " + description + ", label = " + label);
    const style = new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({
        color: '#3399CC',
        width: 1.25
      }),
      text: new Text({
        font: '12px Arial',
        fill: new Fill({ color: '#000' }),
        stroke: new Stroke({
          color: '#fff', width: 2
        }),
        textBaseline: 'top',
        // get the text from the feature - `this` is ol.Feature
        // and show only under certain resolution
        text: label
      }),
      image: new Circle({
        radius: 3,
        fill: new Fill({
          color: [255, 127, 39, 1]
        }),
        stroke: new Stroke({
          color: [255, 0, 0, 1],
          width: 1.5
        })
      }),
      zIndex: 10000
    });
    return style;
  }

  createLayer() {
    if (typeof this.initObj.mapFunc === 'undefined' || this.initObj.mapFunc === null) {
      if (this.map == null ) {
        console.log('Error create layer vector for openlayer map, map variable is null value, need to assign map variable');
        return;
      }
      if (this.psmaSourceVector == null) {
        this.psmaSourceVector = new SourceVector({ features: this.psmaPoints });
      }
      if (this.psmaLayer == null) {
        const option = {
          title: 'PSMA', // not support 6.15.1
          visible: true,
          source: this.psmaSourceVector,
          style: this.psmaStyleFunction
        };
        this.psmaLayer = new LayerVector(option);
      } else { this.map.removeLayer(this.psmaLayer); }
      this.map.addLayer(this.psmaLayer);
    } else {
      const obj = this.initObj.mapFunc.mapObj.psmaCreateLayer(this.psmaPoints);
      this.psmaSourceVector = obj.psmaSourceVector;
      this.psmaLayer = obj.psmaLayer;
    }

  }

  createPoint(coor, index, distance) {
    if (this.isFeatureRemoving || this.callLookUp) { return; }
    const des = (index + 1) + '';
    const properties = { description: des, coor };

    if (!this.psmaPoints) { this.psmaPoints = []; }

    if (typeof this.initObj.mapFunc === 'undefined' || this.initObj.mapFunc === null) {
      const coorMap = proj.transform(coor, SclMapConstantService.EPSG_4326, this.EPSG ); // 'EPSG:3111'
      const iconFeature = new Feature(new Point(coorMap));
      iconFeature.setProperties(properties);
      this.psmaPoints.push(iconFeature);
      this.psmaSourceVector.addFeature(iconFeature);
    } else {
      this.psmaPoints = this.initObj.mapFunc.mapObj.psmaCreatePoint(coor, properties, this.psmaPoints);
    }
  }

  createPointClick(coor, radius) {
    if (this.isFeatureRemoving || this.callLookUp) { return; }

    //// logger.info("createPointClick, coor = " + JSON.stringify(coor) + ", radius = " + radius);
    if (!this.psmaPoints) { this.psmaPoints = []; }
    if (typeof this.initObj.mapFunc === 'undefined' || this.initObj.mapFunc === null) {
      // let wgs84Sphere = new ol.Sphere(6378137);//openlayer 4
      // let circle4326 = ol.geom.Polygon.circular(wgs84Sphere, coor, radius, 64);//openlayer 4
      const circle4326 = circular(coor, radius); // openlayer 5
      const circle3857 = circle4326.clone().transform(SclMapConstantService.EPSG_4326, this.EPSG); // 'EPSG:3111'
      const clickFeature = new Feature(circle3857);
      this.psmaPoints.push(clickFeature);
      this.psmaSourceVector.addFeature(clickFeature);
    } else {
      this.psmaPoints = this.initObj.mapFunc.mapObj.psmaCreatePointClick(coor, radius, this.psmaPoints);
    }
  }

  removeFeatures(isRemove) {
    if (this.psmaPoints == null) {
      this.psmaPoints = [];
      return;
    }

    const obj = this.initObj.mapFunc.mapObj.psmaRemovePoint(this.psmaPoints, this.psmaSourceVector);
    this.psmaPoints = obj.psmaPoints;
    this.psmaSourceVector = obj.psmaSourceVector;

    this.psmaPoints = [];
    this.isFeatureRemoving = isRemove;

  }

  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {
    this.callLookUp = true;
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params is invalid, [0] : autocompleteBox');
      }
      return;
    }
    if (this.autocompleteBox == null) {
      this.autocompleteBox = params[0];
    }


    if (params.length > 1) {
      this.search(params[1], cb, cbErr, cbTimeout);
    }

  }

  removeLookUp() {
    const id = this.initObj.keyName + 'MapGeoPSMA';
    const lst = document.querySelectorAll('#' + id);
    if (lst && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].remove();
      }
    }
    this.autocompleteBox = null;
  }

  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
    }
    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';
    if (this.psmaPoints && this.psmaPoints.length > 0) {
      if (!this.psmaSourceVector) {
        const obj = this.initObj.mapFunc.mapObj.psmaCreateLayer(this.psmaPoints);
        this.psmaSourceVector = obj.psmaSourceVector;
      }
      this.psmaSourceVector.clear();
    }

    this.removeFeatures(true);


    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  search(sPartialAddress, cb, cbErr, cbTimeout) {
    if ( this.apiKey == null) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma address lookup: apiKey is null');
      }
      return;
    }
    if ( sPartialAddress == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma address lookup: text is null');
      }
      return;
    }

    this.callLookUp = true;
    const newText = sPartialAddress.trim();
    if (newText === this.preText) {
      if (cb && typeof cb === 'function') {
        cb(null);
      }
      return;
    }

    this.preText = newText;

    if ( newText.length < 3 ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('psma address lookup: text is less than 3 characters');
      }
      return;
    }

    let link = this.autocompleteUrl + sPartialAddress;
    link = this.getLinkOptions( link);
    this.initObj.httpService.getAPI(link,
      {timeout: this.waitTime},
      {Authorization: this.apiKey}
    ).subscribe(dataResult => {
        if (dataResult && dataResult.suggest) {
          const suggestions = dataResult.suggest;
          const results = [];
          for (let i = 0; i < suggestions.length; i++) {
            const predict = suggestions[i];
            const sugg: any = {};
            sugg.street = predict.address; // show in UI
            sugg.id = predict.id;
            results.push(sugg);
          }

          if (cb && typeof cb === 'function') {
            cb(results);
          }
        } else {
          if (cbErr && typeof cbErr === 'function') {
            cbErr('PSMA reverse Error ');
          }
        }
      },
      error => {
        if ( error.status === -1) {
          if (cbTimeout && typeof cbTimeout === 'function') {
            cbTimeout();
          }
        } else {
          // logger.info(error);
          if (cbErr && typeof cbErr === 'function') {
            cbErr('PSMA Address Matching Error ' + error);
          }
        }
      });


  }

  selectionOption(tpl, model, cb) {
    const link = this.addressUrl + tpl.id;
    this.callLookUp = true;
    this.initObj.httpService.getAPI(link,
      {timeout: this.waitTime},
      {Authorization: this.apiKey}
    ).subscribe(dataResult => {
      if (dataResult != null && dataResult.address) {

        const obj: any = new AddressDetails();
        const properties = dataResult.address.properties;
        // SITE NAME
        if (properties.site_name) {
          obj.properties.locationDescription = properties.site_name;
        }
        // UNIT IDENTIFIER
        if (properties.complex_unit_identifier) {
          obj.properties.unitNo = properties.complex_unit_identifier;
          if (obj.properties.locationDescription) {
            obj.properties.locationDescription += '\n';
          }
          obj.properties.locationDescription += ((properties.complex_unit_type_description ?
            properties.complex_unit_type_description : (properties.complex_unit_type ?
              properties.complex_unit_type : '' )) + ' ' +
            properties.complex_unit_identifier ).trim();
        }
        // LEVEL
        if (properties.complex_level_number) {
          if (obj.properties.locationDescription) {
            obj.properties.locationDescription += '\n';
          }
          obj.properties.locationDescription += ((properties.complex_level_type_description ?
            properties.complex_level_type_description : (properties.complex_level_type ?
              properties.complex_level_type : '')) + ' ' +
            properties.complex_level_number ).trim();
        }
        obj.properties.locationDescription.trim();
        obj.properties.streetNo = properties.street_number_1;
        // DUAL NUMBERS
        if (typeof properties.street_number_2 !== 'undefined' &&
          properties.street_number_2 != null &&
          properties.street_number_2 !== 'null' &&
          properties.street_number_2 !== '') {
          obj.properties.streetNo = obj.properties.streetNo + '-' +
            properties.street_number_2;
        }
        let streetType = '';
        if (typeof properties.street_type_description !== 'undefined' &&
          properties.street_type_description !== null &&
          properties.street_type_description !== 'null' &&
          properties.street_type_description !== '') {
          streetType = properties.street_type_description;
        } else if (typeof properties.street_type !== 'undefined' &&
          properties.street_type !== null &&
          properties.street_type !== 'null' &&
          properties.street_type !== '') {
          streetType = properties.street_type;
        }
        //// logger.info("Street Type is ^"+street_type+"^");
        obj.properties.street = (properties.street_name + ' ' + streetType).trim();
        // SUFFIX
        if (typeof properties.street_suffix !== 'undefined' &&
          properties.street_suffix !== null &&
          properties.street_suffix !== 'null' &&
          properties.street_suffix !== '') {
          obj.properties.street = obj.properties.street + ' ' +
            properties.street_suffix;
        }
        obj.properties.suburb = properties.locality_name;
        obj.properties.postcode = properties.postcode;
        // obj.properties.country = properties.country;
        obj.properties.state = properties.state_territory;

        const lat = dataResult.address.geometry.coordinates[1];
        const lon = dataResult.address.geometry.coordinates[0];
        obj.geometry.coordinates[0] = lon;
        obj.geometry.coordinates[1] = lat;

        if (cb && typeof cb === 'function') {
          cb(obj);
        }
      } else {
        if (cb && typeof cb === 'function') {
          cb('PSMA reverse Error ');
        }
      }
    });
  }

  getLinkOptions( link) {
    if (this.state) { link += '&stateTerritory=' + this.state; }
    return link;
  }


}
